import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
// Models
import { Questionnaire } from './../../shared/models/questionnaire.model';
// Providers
import { QuestionnaireService } from '../../shared/services/questionnaire.service';

@Injectable()
export class QuestionnairesResolve implements Resolve<any> {
  errors = {
    connection: '',
    getData: ''
  };

  constructor(
    private questionnaireService: QuestionnaireService,
    private translateService: TranslateService,
    private notificationsService: NotificationsService
  ) { }

  resolve (route: ActivatedRouteSnapshot): Promise<Array<Questionnaire>> {
    return this.questionnaireService.getQuestionnaires()
      .catch(error => {
        this.fetchErrorTranslation()
          .then((translation: any) => {
            this.notificationsService.error(translation.title, translation.text);
          });
        return [];
      });
  }

  fetchErrorTranslation(): Promise<any> {
    return this.translateService.get([
      'GLOBAL.ERROR.CONNECTION',
      'ADMIN_SETTINGS.REFERENCE_DOCUMENTS.ERROR.LOAD_QUESTIONNAIRES'
    ])
      .toPromise()
      .then((translation: Array<string>) => {
        return {
          title: translation['GLOBAL.ERROR.CONNECTION'],
          text: translation['ADMIN_SETTINGS.REFERENCE_DOCUMENTS.ERROR.LOAD_QUESTIONNAIRES']
        };
      });
  }
}
